
const Resume = () => {
  return (
    <section className="resumeStyling resWork">
          <h1>Work</h1>
          <div className="eduWork">
            <h2>Full-Time Student</h2>
            <p className="divider">June 2022 - Present</p>
            <h2>Corrugated Medium Paper Tester</h2>
            <p className="divider">March 2018 - June 2022</p>
          </div>
        </section>
  )
}

export default Resume